(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ce-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ce-product')) {
  customElements.define('ce-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-ce-variants]').textContent);
      this.form = this.querySelector('.ce-product-form');
      this.slides = [...this.querySelectorAll('[data-ce-slide]')];
      this.slideIndex = 0;
      const initialId = this.form?.querySelector('[name="id"]').value;
      if (initialId) this.selectVariant(initialId);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ce-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-ce-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.ceSlide === thumb.dataset.ceThumb));
        if (event.target.closest('[data-ce-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-ce-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-ce-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.ceQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-ce-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.ceSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-ce-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.ceThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-ce-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-ce-selected-option]');
      if (colorName) colorName.textContent = variant.title;
      const colorSlide = this.slides.findIndex(el => el.dataset.ceOption === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-ce-price]');
      const compare = this.querySelector('[data-ce-compare]');
      const saving = this.querySelector('[data-ce-saving]');
      if (price) price.textContent = variant.priceText;
      document.querySelectorAll('[data-ce-selected-price]').forEach(el => {el.textContent = variant.priceText;});
      document.querySelectorAll('[data-ce-size-choice]').forEach(el => {el.setAttribute('aria-current', String(el.dataset.ceChoose === String(id)));});
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-ce-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-ce-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-ce-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      if (!window.Shopify?.designMode) history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-ce-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-ce-add-text]');
      const error = this.form.querySelector('[data-ce-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.cePageEventsReady) {
  window.cePageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-ce-choose]');
    if (choose) {
      const hero = document.querySelector('ce-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.ceChoose && hero.selectVariant) hero.selectVariant(choose.dataset.ceChoose);
      const destination = hero.querySelector('.ce-options') || hero;
      destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
      const target = hero.querySelector('[data-ce-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-ce-zoom]');
    if (zoom) {
      const section = zoom.closest('.ce-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-ce-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-product')) {
  customElements.define('cp-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-cp-variants]').textContent);
      this.form = this.querySelector('.cp-product-form');
      this.slides = [...this.querySelectorAll('[data-cp-slide]')];
      this.slideIndex = 0;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-cp-variant]')) this.selectVariant(event.target.value);
        if (event.target.matches('[name="quantity"]')) event.target.value = Math.max(1, Math.floor(Number(event.target.value) || 1));
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-cp-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.cpSlide === thumb.dataset.cpThumb));
        if (event.target.closest('[data-cp-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-cp-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-cp-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.cpQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-cp-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.cpSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-cp-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.cpThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-cp-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const price = this.querySelector('[data-cp-price]');
      const compare = this.querySelector('[data-cp-compare]');
      const saving = this.querySelector('[data-cp-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-cp-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-cp-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-cp-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-cp-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-cp-add-text]');
      const error = this.form.querySelector('[data-cp-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      if (!formData.has('quantity')) formData.set('quantity', this.querySelector('[name="quantity"]')?.value || '1');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;button.disabled = false;button.removeAttribute('aria-busy');label.textContent = original;}
    }
  });
}
if (!window.cpPageEventsReady) {
  window.cpPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-cp-choose]');
    if (choose) {
      const hero = document.querySelector('cp-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.cpChoose && hero.selectVariant) hero.selectVariant(choose.dataset.cpChoose);
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-cp-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-cp-zoom]');
    if (zoom) {
      const section = zoom.closest('.cp-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-cp-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enamel-product-hero"] && !Shopify.designMode) return;
  try {
    
function setupEnamel(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
 const show=(id)=>{root.querySelectorAll('[data-frame]').forEach(e=>e.hidden=e.dataset.frame!==String(id));root.querySelectorAll('[data-thumb]').forEach(e=>e.setAttribute('aria-pressed',String(e.dataset.thumb===String(id))));};
 root.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>show(b.dataset.thumb)));
 const select=root.querySelector('[data-variant]');
 const initial=select?variants.find(v=>String(v.id)===select.value):variants[0];if(initial&&initial.featured_media)show(initial.featured_media.id);
 if(select)select.addEventListener('change',()=>{
 const v=variants.find(v=>String(v.id)===select.value);if(!v)return;
 root.querySelectorAll('[data-variant-input]').forEach(e=>e.value=v.id);
 const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:Shopify.currency.active}).format(n/100);
 const p=root.querySelector('[data-price]');if(p)p.textContent=money(v.price);
 const c=root.querySelector('[data-compare]');if(c)c.textContent=v.compare_at_price>v.price?money(v.compare_at_price):'';
 root.querySelectorAll('[data-buy]').forEach(b=>{b.disabled=!v.available;b.textContent=v.available?b.dataset.availableLabel:b.dataset.unavailableLabel;});
 if(v.featured_media)show(v.featured_media.id);
 const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
 });
}
document.querySelectorAll('[data-ep]').forEach(setupEnamel);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ep]').forEach(setupEnamel));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fp-product')) {
  customElements.define('fp-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-fp-variants]').textContent);
      this.form = this.querySelector('.fp-product-form');
      this.slides = [...this.querySelectorAll('[data-fp-slide]')];
      this.slideIndex = 0;
      const initialId = this.form?.querySelector('[name="id"]').value;
      if (initialId) this.selectVariant(initialId);
      this.showSlide(0);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-fp-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-fp-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.fpSlide === thumb.dataset.fpThumb));
        if (event.target.closest('[data-fp-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-fp-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-fp-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.fpQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-fp-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.fpSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-fp-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.fpThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-fp-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-fp-selected-option]');
      if (colorName) colorName.textContent = variant.title;
      const colorSlide = this.slides.findIndex(el => el.dataset.fpOption === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-fp-price]');
      const compare = this.querySelector('[data-fp-compare]');
      const saving = this.querySelector('[data-fp-saving]');
      if (price) price.textContent = variant.priceText;
      document.querySelectorAll('[data-fp-selected-price]').forEach(el => {el.textContent = variant.priceText;});
      document.querySelectorAll('[data-fp-size-choice]').forEach(el => {el.setAttribute('aria-current', String(el.dataset.fpChoose === String(id)));});
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-fp-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-fp-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-fp-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      if (!window.Shopify?.designMode) history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-fp-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-fp-add-text]');
      const error = this.form.querySelector('[data-fp-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.fpPageEventsReady) {
  window.fpPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-fp-choose]');
    if (choose) {
      const hero = document.querySelector('fp-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.fpChoose && hero.selectVariant) hero.selectVariant(choose.dataset.fpChoose);
      const destination = hero.querySelector('.fp-buy') || hero;
      destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
      const target = hero.querySelector('[data-fp-add]');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-fp-zoom]');
    if (zoom) {
      const section = zoom.closest('.fp-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-fp-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gc-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gc-product')) {
  customElements.define('gc-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-gc-variants]').textContent);
      this.form = this.querySelector('.gc-product-form');
      this.slides = [...this.querySelectorAll('[data-gc-slide]')];
      this.slideIndex = 0;
      this.addEventListener('keydown', event => {if (event.key === 'ArrowRight' && event.target.closest('.gc-gallery')) this.showSlide(this.slideIndex + 1); if (event.key === 'ArrowLeft' && event.target.closest('.gc-gallery')) this.showSlide(this.slideIndex - 1);});
      const initialId = new URL(location.href).searchParams.get('variant');
      if (initialId) this.selectVariant(initialId);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-gc-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gc-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.gcSlide === thumb.dataset.gcThumb));
        if (event.target.closest('[data-gc-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-gc-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-gc-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.gcQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-gc-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.gcSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-gc-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.gcThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-gc-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-gc-selected-color]');
      if (colorName) colorName.textContent = variant.title;
      const includes = this.querySelector('[data-gc-includes]');
      const note = this.querySelector('[data-gc-includes-data]');
      if (includes && note) includes.textContent = variant.isSet ? note.dataset.setNote : note.dataset.cupsNote;
      const colorSlide = this.slides.findIndex(el => el.dataset.gcOption === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-gc-price]');
      const compare = this.querySelector('[data-gc-compare]');
      const saving = this.querySelector('[data-gc-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-gc-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-gc-add-text]').textContent = variant.available ? (variant.isSet ? this.dataset.gcSetLabel : this.dataset.gcCupsLabel) : this.dataset.soldLabel;
        this.form.querySelector('[data-gc-error]').hidden = true;
      }
      document.querySelectorAll('[data-gc-selected-price]').forEach(el => {el.textContent = variant.priceText;});
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-gc-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-gc-add-text]');
      const error = this.form.querySelector('[data-gc-error]');
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? (selected.isSet ? this.dataset.gcSetLabel : this.dataset.gcCupsLabel) : this.dataset.soldLabel;}
    }
  });
}
if (!window.gcPageEventsReady) {
  window.gcPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-gc-choose]');
    if (choose) {
      const hero = document.querySelector('gc-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.gcChoose && hero.selectVariant) hero.selectVariant(choose.dataset.gcChoose);
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-gc-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-gc-zoom]');
    if (zoom) {
      const section = zoom.closest('.gc-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-gc-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-product')) {
  customElements.define('lf-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.classList.add('lf-enhanced');
      this.variants = JSON.parse(this.querySelector('[data-lf-variants]').textContent);
      this.form = this.querySelector('.lf-product-form');
      this.slides = [...this.querySelectorAll('[data-lf-slide]')];
      this.slideIndex = 0;
      const initialId = new URL(location.href).searchParams.get('variant');
      if (initialId) this.selectVariant(initialId);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-lf-color-option], [data-lf-set-option]')) {
          const color = this.querySelector('[data-lf-color-option]:checked')?.value;
          const set = this.querySelector('[data-lf-set-option]:checked')?.value;
          const variant = this.variants.find(v => (!color || v.color === color) && (!set || v.set === set));
          if (variant) this.selectVariant(variant.id, event.target.matches('[data-lf-color-option]'));
        }
        if (event.target.matches('[name="quantity"]')) {
          event.target.value = Math.max(1, Math.floor(Number(event.target.value) || 1));
        }
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-lf-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.lfSlide === thumb.dataset.lfThumb));
        if (event.target.closest('[data-lf-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-lf-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-lf-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          if (!input) return;
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.lfQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-lf-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.lfSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-lf-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.lfThumb === key)));
    }
    selectVariant(id, updateImage = true) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-lf-color-option]').forEach(input => {input.checked = input.value === variant.color;});
      this.querySelectorAll('[data-lf-set-option]').forEach(input => {input.checked = input.value === variant.set;});
      this.querySelectorAll('[data-lf-set-price]').forEach(el => {
        const other = this.variants.find(v => v.color === variant.color && v.set === el.dataset.lfSetPrice);
        if (other) el.textContent = other.priceText;
      });
      this.querySelectorAll('[data-lf-set-compare]').forEach(el => {
        const other = this.variants.find(v => v.color === variant.color && v.set === el.dataset.lfSetCompare);
        if (other) {el.textContent = other.compareText; el.hidden = other.compare <= other.price;}
      });
      this.querySelectorAll('[data-lf-unit]').forEach(el => {
        const other = this.variants.find(v => v.color === variant.color && v.set === el.dataset.lfUnit);
        if (other) el.textContent = other.unitText + ' ' + this.dataset.unitLabel;
      });
      const colorName = this.querySelector('[data-lf-selected-color]');
      if (colorName) colorName.textContent = variant.color;
      const colorSlide = this.slides.findIndex(el => el.dataset.lfColor === variant.color);
      if (updateImage && colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-lf-price]');
      const compare = this.querySelector('[data-lf-compare]');
      const saving = this.querySelector('[data-lf-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-lf-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-lf-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-lf-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-lf-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-lf-add-text]');
      const error = this.form.querySelector('[data-lf-error]');
      
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.lfPageEventsReady) {
  window.lfPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-lf-choose]');
    if (choose) {
      const hero = document.querySelector('lf-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.lfChoose && hero.selectVariant) hero.selectVariant(choose.dataset.lfChoose);
      if (choose.dataset.lfFinish && hero.selectVariant) {
        const set = hero.querySelector('[data-lf-set-option]:checked')?.value;
        const match = hero.variants.find(v => v.color === choose.dataset.lfFinish && (!set || v.set === set));
        if (match) hero.selectVariant(match.id);
      }
      if (choose.dataset.lfSet && hero.selectVariant) {
        const color = hero.querySelector('[data-lf-color-option]:checked')?.value;
        const match = hero.variants.find(v => v.set === choose.dataset.lfSet && (!color || v.color === color));
        if (match) hero.selectVariant(match.id);
      }
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-lf-color-option]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-lf-zoom]');
    if (zoom) {
      const section = zoom.closest('.lf-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-lf-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-product')) {
  customElements.define('mc-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-mc-variants]').textContent);
      this.form = this.querySelector('.mc-product-form');
      this.slides = [...this.querySelectorAll('[data-mc-slide]')];
      this.slideIndex = 0;
      const initialId = this.form?.querySelector('[name="id"]').value;
      if (initialId) this.selectVariant(initialId);
      this.showSlide(0);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-mc-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-mc-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.mcSlide === thumb.dataset.mcThumb));
        if (event.target.closest('[data-mc-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-mc-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-mc-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.mcQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-mc-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.mcSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-mc-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mcThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-mc-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-mc-selected-option]');
      if (colorName) colorName.textContent = variant.title;
      const colorSlide = this.slides.findIndex(el => el.dataset.mcOption === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-mc-price]');
      const compare = this.querySelector('[data-mc-compare]');
      const saving = this.querySelector('[data-mc-saving]');
      if (price) price.textContent = variant.priceText;
      document.querySelectorAll('[data-mc-selected-price]').forEach(el => {el.textContent = variant.priceText;});
      document.querySelectorAll('[data-mc-size-choice]').forEach(el => {el.setAttribute('aria-current', String(el.dataset.mcChoose === String(id)));});
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-mc-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-mc-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-mc-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      if (!window.Shopify?.designMode) history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-mc-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-mc-add-text]');
      const error = this.form.querySelector('[data-mc-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.mcPageEventsReady) {
  window.mcPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-mc-choose]');
    if (choose) {
      const hero = document.querySelector('mc-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.mcChoose && hero.selectVariant) hero.selectVariant(choose.dataset.mcChoose);
      const destination = hero.querySelector('.mc-buy') || hero;
      destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
      const target = hero.querySelector('[data-mc-add]');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-mc-zoom]');
    if (zoom) {
      const section = zoom.closest('.mc-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-mc-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mesh-sink-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mesh-sink-product')){
  customElements.define('mesh-sink-product',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.form=this.querySelector('.mesh-product-form');
      this.addButton=this.querySelector('[data-add]');
      this.status=this.querySelector('[data-status]');
      this.dialog=this.querySelector('dialog');
      this.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>this.showImage(button.dataset.thumb)));
      this.querySelectorAll('[data-slide]').forEach(button=>button.addEventListener('click',()=>{
        const clone=button.querySelector('img').cloneNode(true);
        clone.removeAttribute('loading');
        this.querySelector('[data-zoom-image]').replaceChildren(clone);
        this.dialog.showModal();
      }));
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close()});
      this.querySelectorAll('[data-variant]').forEach(input=>input.addEventListener('change',()=>this.setVariant(input)));
      this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{
        const input=this.querySelector('input[name="quantity"]');
        const next=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.step));
        input.value=String(next);input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      if(this.form)this.form.addEventListener('submit',event=>this.addToCart(event));
      this.onBlockSelect=event=>{
        if(!this.contains(event.target))return;
        const slide=event.target.closest('[data-slide]')||event.target.querySelector('[data-slide]');
        if(slide)this.showImage(slide.dataset.slide);
      };
      document.addEventListener('shopify:block:select',this.onBlockSelect);
    }
    disconnectedCallback(){document.removeEventListener('shopify:block:select',this.onBlockSelect)}
    showImage(index){
      this.querySelectorAll('[data-slide]').forEach(slide=>slide.hidden=slide.dataset.slide!==String(index));
      this.querySelectorAll('[data-thumb]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.thumb===String(index))));
    }
    setVariant(input){
      const d=input.dataset;
      const hidden=this.querySelector('[data-variant-id]');
      if(hidden){hidden.value=input.value;hidden.dispatchEvent(new Event('change',{bubbles:true}))}
      const price=this.querySelector('[data-price-output]');if(price)price.textContent=d.price;
      const compare=this.querySelector('[data-compare-output]');if(compare){compare.textContent=d.compare;compare.hidden=d.onSale!=='true'}
      const saving=this.querySelector('[data-saving-output]');if(saving){saving.textContent=d.saving;saving.hidden=d.onSale!=='true'}
      this.querySelectorAll('[data-color-label]').forEach(label=>label.textContent=d.color);
      if(this.addButton){this.addButton.disabled=d.available!=='true';this.querySelector('[data-add-text]').textContent=d.available==='true'?this.dataset.addLabel:this.dataset.soldLabel}
      const image=Array.from(this.querySelectorAll('[data-slide]')).find(slide=>slide.dataset.color===d.color);
      if(image)this.showImage(image.dataset.slide);
      const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
      if(this.status)this.status.hidden=true;
      const cartLink=this.querySelector('[data-cart-link]');if(cartLink)cartLink.hidden=true;
    }
    async addToCart(event){
      event.preventDefault();
      if(this.addButton.disabled)return;
      this.addButton.disabled=true;this.addButton.setAttribute('aria-busy','true');
      this.status.hidden=true;
      const data=new FormData(this.form);
      const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      if(cart&&typeof cart.getSectionsToRender==='function'){
        data.append('sections',cart.getSectionsToRender().map(section=>section.id).join(','));
        data.append('sections_url',location.pathname);
        if(typeof cart.setActiveElement==='function')cart.setActiveElement(document.activeElement);
      }
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||result.message||this.dataset.errorLabel);
        this.status.textContent=this.dataset.successLabel;
        this.status.hidden=false;this.querySelector('[data-cart-link]').hidden=false;
        if(cart&&typeof cart.renderContents==='function'&&result.sections){
          try{cart.renderContents(result);cart.classList.remove('is-empty')}catch(e){this.status.focus()}
        }
        document.dispatchEvent(new CustomEvent('mesh:cart-added',{detail:result}));
      }catch(error){this.status.textContent=error.message||this.dataset.errorLabel;this.status.hidden=false;this.status.focus()}
      finally{this.addButton.disabled=false;this.addButton.removeAttribute('aria-busy')}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mps-product-hero"] && !Shopify.designMode) return;
  try {
    
function initMpsHero(root){
 if(root.dataset.mpsReady)return;root.dataset.mpsReady='true';
 const show=(id)=>{if(!id)return;root.querySelectorAll('[data-mps-media]').forEach(el=>el.hidden=el.dataset.mpsMedia!==id);root.querySelectorAll('[data-mps-target]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.mpsTarget===id)));};
 root.querySelectorAll('[data-mps-target]').forEach(button=>button.addEventListener('click',()=>show(button.dataset.mpsTarget)));
 const selector=root.querySelector('[data-mps-variant]');
 if(selector)selector.addEventListener('change',()=>{
  const option=selector.selectedOptions[0];show(option.dataset.media);
  const priceTemplate=root.querySelector('[data-mps-variant-price="'+option.value+'"]');
  const priceOutput=root.querySelector('[data-mps-price-output]');
  if(priceTemplate&&priceOutput)priceOutput.replaceChildren(priceTemplate.content.cloneNode(true));
  root.querySelectorAll('[data-mps-add]').forEach(el=>{el.disabled=option.dataset.available!=='true';el.textContent=el.disabled?el.dataset.soldLabel:el.dataset.addLabel;});
  const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
 });
}
document.querySelectorAll('[data-mps-hero]').forEach(initMpsHero);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mps-hero]').forEach(initMpsHero));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mt-product')) {
  customElements.define('mt-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-mt-variants]').textContent);
      this.form = this.querySelector('.mt-product-form');
      this.slides = [...this.querySelectorAll('[data-mt-slide]')];
      this.slideIndex = 0;
      const initialId = new URL(location.href).searchParams.get('variant');
      if (initialId) this.selectVariant(initialId);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-mt-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-mt-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.mtSlide === thumb.dataset.mtThumb));
        if (event.target.closest('[data-mt-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-mt-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-mt-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.mtQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-mt-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.mtSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-mt-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mtThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-mt-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-mt-selected-color]');
      if (colorName) colorName.textContent = variant.displayTitle;
      const colorSlide = this.slides.findIndex(el => el.dataset.mtColor === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-mt-price]');
      const compare = this.querySelector('[data-mt-compare]');
      const saving = this.querySelector('[data-mt-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-mt-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-mt-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-mt-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-mt-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-mt-add-text]');
      const error = this.form.querySelector('[data-mt-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.mtPageEventsReady) {
  window.mtPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-mt-choose]');
    if (choose) {
      const hero = document.querySelector('mt-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.mtChoose && hero.selectVariant) hero.selectVariant(choose.dataset.mtChoose);
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-mt-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-mt-zoom]');
    if (zoom) {
      const section = zoom.closest('.mt-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-mt-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pan-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pan-product')) {
  customElements.define('pan-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-pan-variants]').textContent);
      this.form = this.querySelector('.pan-product-form');
      this.slides = [...this.querySelectorAll('[data-pan-slide]')];
      this.slideIndex = 0;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-pan-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-pan-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.panSlide === thumb.dataset.panThumb));
        if (event.target.closest('[data-pan-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-pan-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-pan-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.panQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-pan-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.panSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-pan-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.panThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-pan-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const price = this.querySelector('[data-pan-price]');
      const compare = this.querySelector('[data-pan-compare]');
      const saving = this.querySelector('[data-pan-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-pan-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-pan-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-pan-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-pan-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-pan-add-text]');
      const error = this.form.querySelector('[data-pan-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;button.disabled = false;button.removeAttribute('aria-busy');label.textContent = original;}
    }
  });
}
if (!window.panPageEventsReady) {
  window.panPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-pan-choose]');
    if (choose) {
      const hero = document.querySelector('pan-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.panChoose && hero.selectVariant) hero.selectVariant(choose.dataset.panChoose);
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-pan-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-pan-zoom]');
    if (zoom) {
      const section = zoom.closest('.pan-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-pan-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-brand-message"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-collection-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-community-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  (function () {
    if (window.__tbCountInit) return;
    window.__tbCountInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function animate(el) {
      var raw = el.getAttribute('data-tb-target') || el.textContent;
      var m = raw.match(/([0-9]+(?:\.[0-9]+)?)/);
      if (!m || reduce) { return; }
      var num = parseFloat(m[1]);
      var prefix = raw.slice(0, m.index);
      var suffix = raw.slice(m.index + m[1].length);
      var decimals = (m[1].split('.')[1] || '').length;
      var start = null, dur = 1500;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = (num * eased).toFixed(decimals);
        el.textContent = prefix + val + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + num.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(step);
    }
    function run() {
      var els = document.querySelectorAll('[data-tb-count]:not([data-tb-done])');
      if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-tb-done', ''); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.setAttribute('data-tb-done', '');
            animate(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-trust-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbRevealInit) return;
    window.__tbRevealInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run() {
      var nodes = document.querySelectorAll('.tb-reveal:not(.tb-in)');
      if (reduce || !('IntersectionObserver' in window)) {
        nodes.forEach(function (n) { n.classList.add('tb-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sink-organizer-pdp"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sop-root]').forEach((root) => {
    const variantScript = root.parentElement.querySelector('[data-sop-variants]') || document.querySelector('[data-sop-variants]');
    if (!variantScript) return;
    const variants = JSON.parse(variantScript.textContent);
    const mainImage = root.querySelector('.sop-main-image');
    const colorButtons = [...root.querySelectorAll('[data-sop-color]')];
    const packButtons = [...root.querySelectorAll('[data-sop-pack]')];
    const thumbButtons = [...root.querySelectorAll('[data-sop-thumb]')];
    const variantInput = root.querySelector('[data-sop-variant-id]');
    const price = root.querySelector('[data-sop-price]');
    const compare = root.querySelector('[data-sop-compare]');
    const save = root.querySelector('[data-sop-save]');
    const add = root.querySelector('[data-sop-add]');
    const colorLabel = root.querySelector('[data-sop-color-label]');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    const state = { color: 'Gun Gray', pack: '1 Piece' };

    const setMainImage = (src, alt) => {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.srcset = '';
      mainImage.alt = alt || '';
    };

    const updateVariant = () => {
      const variant = variants.find((item) => item.options[0] === state.color && item.options[1] === state.pack);
      if (!variant) {
        add.disabled = true;
        add.textContent = 'UNAVAILABLE';
        return;
      }
      variantInput.value = variant.id;
      price.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = money(variant.compare_at_price);
        save.hidden = false;
        save.textContent = `Save ${money(variant.compare_at_price - variant.price)}`;
      } else {
        compare.hidden = true;
        save.hidden = true;
      }
      add.disabled = !variant.available;
      add.textContent = variant.available ? `ADD TO CART · ${money(variant.price)}` : 'SOLD OUT';
    };

    colorButtons.forEach((button) => button.addEventListener('click', () => {
      state.color = button.dataset.sopColor;
      colorLabel.textContent = state.color;
      colorButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      setMainImage(button.dataset.image, button.dataset.alt);
      updateVariant();
    }));

    packButtons.forEach((button) => button.addEventListener('click', () => {
      state.pack = button.dataset.sopPack;
      packButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      updateVariant();
    }));

    thumbButtons.forEach((button) => button.addEventListener('click', () => {
      thumbButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      setMainImage(button.dataset.src, button.dataset.alt);
    }));

    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-product')) {
  customElements.define('sl-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-sl-variants]').textContent);
      this.form = this.querySelector('.sl-product-form');
      this.slides = [...this.querySelectorAll('[data-sl-slide]')];
      this.slideIndex = 0;
      const initialId = new URL(location.href).searchParams.get('variant');
      if (initialId) this.selectVariant(initialId);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-sl-variant]')) this.selectVariant(event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-sl-thumb]');
        if (thumb) this.showSlide(this.slides.findIndex(el => el.dataset.slSlide === thumb.dataset.slThumb));
        if (event.target.closest('[data-sl-prev]')) this.showSlide(this.slideIndex - 1);
        if (event.target.closest('[data-sl-next]')) this.showSlide(this.slideIndex + 1);
        const quantity = event.target.closest('[data-sl-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.slQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-sl-slide]');
        if (slide && this.contains(slide)) this.showSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select', this.blockSelect);
    }
    disconnectedCallback() {
      if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
    }
    showSlide(index) {
      if (!this.slides.length) return;
      this.slideIndex = (index + this.slides.length) % this.slides.length;
      const key = this.slides[this.slideIndex].dataset.slSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== this.slideIndex;});
      this.querySelectorAll('[data-sl-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.slThumb === key)));
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelectorAll('[data-sl-variant]').forEach(input => {input.checked = String(input.value) === String(id);});
      const colorName = this.querySelector('[data-sl-selected-color]');
      if (colorName) colorName.textContent = variant.title;
      const colorSlide = this.slides.findIndex(el => el.dataset.slColor === variant.title);
      if (colorSlide >= 0) this.showSlide(colorSlide);
      const price = this.querySelector('[data-sl-price]');
      const compare = this.querySelector('[data-sl-compare]');
      const saving = this.querySelector('[data-sl-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        const button = this.form.querySelector('[data-sl-add]');
        button.disabled = !variant.available;
        this.form.querySelector('[data-sl-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-sl-error]').hidden = true;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-sl-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-sl-add-text]');
      const error = this.form.querySelector('[data-sl-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }
  });
}
if (!window.slPageEventsReady) {
  window.slPageEventsReady = true;
  document.addEventListener('click', event => {
    const choose = event.target.closest('[data-sl-choose]');
    if (choose) {
      const hero = document.querySelector('sl-product');
      if (!hero) return;
      event.preventDefault();
      if (choose.dataset.slChoose && hero.selectVariant) hero.selectVariant(choose.dataset.slChoose);
      hero.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const target = hero.querySelector('[data-sl-variant]:checked');
      if (target) target.focus({preventScroll:true});
    }
    const zoom = event.target.closest('[data-sl-zoom]');
    if (zoom) {
      const section = zoom.closest('.sl-section');
      const modal = section.querySelector('dialog');
      const source = zoom.querySelector('img');
      if (modal && source) {modal.querySelector('img').src = source.currentSrc || source.src;modal.querySelector('img').alt = source.alt;modal.showModal();}
    }
    const close = event.target.closest('[data-sl-modal-close]');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-product')) {
  customElements.define('st-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-st-variants]').textContent);
      this.form = this.querySelector('.st-product-form');
      this.slides = [...this.querySelectorAll('[data-st-slide]')];
      this.slideIndex = 0;
      this.selectVariant(this.form?.querySelector('[name="id"]')?.value || this.variants[0]?.id);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-st-option]')) this.chooseOption(Number(event.target.dataset.stPosition), event.target.value);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-st-thumb]');
        if (thumb) this.chooseSlide(this.slides.findIndex(el => el.dataset.stSlide === thumb.dataset.stThumb));
        if (event.target.closest('[data-st-prev]')) this.stepSlide(-1);
        if (event.target.closest('[data-st-next]')) this.stepSlide(1);
        const quantity = event.target.closest('[data-st-quantity]');
        if (quantity) {
          const input = this.querySelector('[name="quantity"]');
          input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.stQuantity));
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      if (this.form) this.form.addEventListener('submit', event => this.addToCart(event));
      this.blockSelect = event => {
        const slide = event.target.closest('[data-st-slide]');
        if (slide && this.contains(slide)) this.chooseSlide(this.slides.indexOf(slide));
      };
      document.addEventListener('shopify:block:select',this.blockSelect);
    }
    disconnectedCallback() {if (this.blockSelect) document.removeEventListener('shopify:block:select',this.blockSelect);}
    chooseOption(position,value) {
      const options = [...this.currentVariant.options];
      options[position] = value;
      const match = this.variants.find(v => v.options.every((o,i) => o === options[i]));
      if (match) this.selectVariant(match.id);
    }
    chooseSize(value) {this.chooseOption(0,value);}
    chooseSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const match = this.variants.find(v => v.options[0] === slide.dataset.stSize && v.options[1] === slide.dataset.stColor);
      if (match) this.selectVariant(match.id);
      else this.showSlide(index);
    }
    stepSlide(direction) {
      const visible = this.slides.filter(el => el.dataset.stSize === this.currentVariant.options[0]);
      const index = visible.indexOf(this.slides[this.slideIndex]);
      const next = visible[(index + direction + visible.length) % visible.length];
      if (next) this.chooseSlide(this.slides.indexOf(next));
    }
    showSlide(index) {
      if (index < 0 || !this.slides.length) return;
      this.slideIndex = index;
      const key = this.slides[index].dataset.stSlide;
      this.slides.forEach((el,i) => {el.hidden = i !== index;});
      this.querySelectorAll('[data-st-thumb]').forEach(el => {
        el.hidden = el.dataset.stSize !== this.currentVariant.options[0];
        el.setAttribute('aria-pressed',String(el.dataset.stThumb === key));
      });
    }
    selectVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.currentVariant = variant;
      this.querySelectorAll('[data-st-option]').forEach(input => {input.checked = input.value === variant.options[Number(input.dataset.stPosition)];});
      this.querySelectorAll('[data-st-option-selected]').forEach(el => {el.textContent = variant.options[Number(el.dataset.stOptionSelected)];});
      const galleryName = this.querySelector('[data-st-gallery-selection]');
      if (galleryName) galleryName.textContent = variant.title;
      const image = this.slides.findIndex(el => el.dataset.stSize === variant.options[0] && el.dataset.stColor === variant.options[1]);
      if (image >= 0) this.showSlide(image);
      const price = this.querySelector('[data-st-price]');
      const compare = this.querySelector('[data-st-compare]');
      const saving = this.querySelector('[data-st-saving]');
      if (price) price.textContent = variant.priceText;
      if (compare) {compare.textContent = variant.compareText;compare.hidden = variant.compare <= variant.price;}
      if (saving) {saving.textContent = variant.savingText;saving.hidden = variant.compare <= variant.price;}
      document.querySelectorAll('[data-st-selected-price]').forEach(el => {el.textContent = variant.priceText;});
      document.querySelectorAll('[data-st-size-choice]').forEach(el => {el.setAttribute('aria-current',String(el.dataset.stSizeValue === variant.options[0]));});
      if (this.form) {
        const input = this.form.querySelector('[name="id"]');input.value = variant.id;input.dispatchEvent(new Event('change',{bubbles:true}));
        this.form.querySelector('[data-st-add]').disabled = !variant.available;
        this.form.querySelector('[data-st-add-text]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.form.querySelector('[data-st-error]').hidden = true;
      }
      if (!window.Shopify?.designMode) {const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    }
    async addToCart(event) {
      event.preventDefault();
      const button = this.form.querySelector('[data-st-add]');
      if (button.disabled || this.busy) return;
      this.busy = true;
      const label = this.form.querySelector('[data-st-add-text]');
      const error = this.form.querySelector('[data-st-error]');
      const original = label.textContent;
      button.disabled = true;button.setAttribute('aria-busy','true');label.textContent = this.dataset.addingLabel;error.hidden = true;
      const formData = new FormData(this.form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url',location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorLabel);
        if (cart && typeof cart.renderContents === 'function' && data.sections && Object.values(data.sections).every(Boolean)) {
          cart.classList.remove('is-empty');cart.renderContents(data);
        } else location.href = this.dataset.cartUrl;
      } catch (e) {error.textContent = e.message || this.dataset.errorLabel;error.hidden = false;}
      finally {this.busy = false;const selected = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);button.disabled = !selected?.available;button.removeAttribute('aria-busy');label.textContent = selected?.available ? this.dataset.addLabel : this.dataset.soldLabel;}
    }

  });
}
if (!window.stPageEventsReady) {
  window.stPageEventsReady = true;
  document.addEventListener('click',event => {
    const choose = event.target.closest('[data-st-choose]');
    if (!choose) return;
    const hero = document.querySelector('st-product');
    if (!hero) return;
    event.preventDefault();
    if (choose.dataset.stSizeValue && hero.chooseSize) hero.chooseSize(choose.dataset.stSizeValue);
    else if (choose.dataset.stChoose && hero.selectVariant) hero.selectVariant(choose.dataset.stChoose);
    const destination = hero.querySelector('.st-options') || hero;
    destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
    hero.querySelector('[data-st-option]:checked')?.focus({preventScroll:true});
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeEditorialReveal = (scope = document) => {
      const items = scope.querySelectorAll('.tb-editorial-reveal:not(.tb-editorial-in)');
      if (!items.length) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('tb-editorial-in'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('tb-editorial-in');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
      items.forEach((item) => observer.observe(item));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeEditorialReveal());
    } else {
      initializeEditorialReveal();
    }
    document.addEventListener('shopify:section:load', (event) => initializeEditorialReveal(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-hammered-pan"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.tbhipReady === 'true') return;
      root.dataset.tbhipReady = 'true';

      const gallery = root.querySelector('[data-tbhip-gallery]');
      if (gallery) {
        const slides = Array.from(gallery.querySelectorAll('[data-tbhip-slide]'));
        const thumbs = Array.from(gallery.querySelectorAll('[data-tbhip-thumb]'));
        const current = gallery.querySelector('[data-tbhip-current]');
        let activeIndex = 0;

        const render = (index) => {
          if (!slides.length) return;
          activeIndex = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === activeIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });
          thumbs.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === activeIndex;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          if (current) current.textContent = String(activeIndex + 1);
        };

        const show = (index) => {
          if (document.startViewTransition) {
            document.startViewTransition(() => render(index));
          } else {
            render(index);
          }
        };

        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => show(index));
          thumb.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              thumbs[(index + 1) % thumbs.length].focus();
              show(index + 1);
            }
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              thumbs[(index - 1 + thumbs.length) % thumbs.length].focus();
              show(index - 1);
            }
          });
        });

        gallery.querySelector('[data-tbhip-previous]')?.addEventListener('click', () => show(activeIndex - 1));
        gallery.querySelector('[data-tbhip-next]')?.addEventListener('click', () => show(activeIndex + 1));
      }

      const quantity = root.querySelector('.tbhip-quantity__control input');
      if (quantity) {
        root.querySelector('[data-tbhip-minus]')?.addEventListener('click', () => {
          const minimum = Number(quantity.min || 1);
          quantity.value = String(Math.max(minimum, Number(quantity.value || minimum) - 1));
        });
        root.querySelector('[data-tbhip-plus]')?.addEventListener('click', () => {
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          quantity.value = String(Math.min(maximum, Number(quantity.value || 1) + 1));
        });
      }
    };

    document.querySelectorAll('[data-tbhip]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-tbhip]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-rotating-organizer"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click', function(event) {
  var thumb = event.target.closest('.tb-ro__thumb');
  if (!thumb) return;
  var gallery = thumb.closest('.tb-ro__gallery');
  var image = gallery.querySelector('.tb-ro__main-image img');
  if (!image) return;
  image.src = thumb.dataset.full;
  image.srcset = '';
  image.alt = thumb.dataset.alt || '';
  var caption = gallery.querySelector('[data-image-caption]');
  if (caption) caption.textContent = image.alt;
  gallery.querySelectorAll('.tb-ro__thumb').forEach(function(item) {
    item.classList.toggle('is-active', item === thumb);
    item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
  });
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('.tb-ro__color input')) return;
  var input = event.target;
  var section = input.closest('.tb-ro');
  var prices = section.querySelector('.tb-ro__prices');
  var priceTemplate = section.querySelector('template[data-variant-price="' + input.value + '"]');
  var name = section.querySelector('[data-color-name]');
  var button = section.querySelector('.tb-ro__atc');
  if (prices && priceTemplate) {
    prices.replaceChildren(priceTemplate.content.cloneNode(true));
  }
  if (name) name.textContent = input.dataset.color;
  if (input.dataset.image) {
    var image = section.querySelector('.tb-ro__main-image img');
    if (image) { image.src = input.dataset.image; image.srcset = ''; image.alt = input.dataset.imageAlt || ''; }
    var caption = section.querySelector('[data-image-caption]');
    if (caption) caption.textContent = input.dataset.imageAlt || '';
    section.querySelectorAll('.tb-ro__thumb').forEach(function(thumb) {
      var active = thumb.dataset.full === input.dataset.image;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  if (button) {
    button.disabled = input.dataset.available !== 'true';
    button.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
  }
  var url = new URL(window.location.href);
  url.searchParams.set('variant', input.value);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-stack-serve-pan"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click', function(event) {
  var thumb = event.target.closest('.tb-ss__thumb');
  if (!thumb) return;
  var gallery = thumb.closest('.tb-ss__gallery');
  var image = gallery.querySelector('.tb-ss__main-image img');
  if (!image) return;
  image.src = thumb.dataset.full;
  image.srcset = '';
  image.alt = thumb.dataset.alt || '';
  gallery.querySelectorAll('.tb-ss__thumb').forEach(function(item) {
    item.classList.toggle('is-active', item === thumb);
    item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
  });
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('.tb-ss__color input')) return;
  var input = event.target;
  var section = input.closest('.tb-ss');
  var prices = section.querySelector('.tb-ss__prices');
  var priceTemplate = section.querySelector('template[data-variant-price="' + input.value + '"]');
  var name = section.querySelector('[data-color-name]');
  var button = section.querySelector('.tb-ss__atc');
  if (prices && priceTemplate) {
    prices.replaceChildren(priceTemplate.content.cloneNode(true));
  }
  if (name) name.textContent = input.dataset.color;
  if (button) {
    button.disabled = input.dataset.available !== 'true';
    button.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
  }
  var url = new URL(window.location.href);
  url.searchParams.set('variant', input.value);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();
})();
